<template>
  <b-modal
    :active.sync="showModal"
    :width="450"
  >
    <div
      class="modal-card"
      style="width: auto"
    >
      <header class="modal-card-head is-block">
        <span class="icon-static xl large-download" />
        <h4 class="title is-4">
          Download with your subscription
        </h4>
      </header>
      <section
        v-if="track"
        class="modal-card-body text is-centered"
      >
        <div class="columns is-vcentered">
          <div
            v-if="track.cover_thumbnail"
            class="column cover is-narrow"
          >
            <img
              class="image is-64x64"
              :src="track.cover_thumbnail"
            >
          </div>
          <div class="column has-text-left">
            <p class="text label-medium">
              {{ track.display_title }}
              <span
                v-if="track.explicit == 'Explicit' || track.explicit == true"
                class="tag explicit"
              >Explicit</span>
            </p>
            <p class="text small track-artist">
              {{ track.artist.name }}
            </p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot is-block">
        <button
          class="button is-fullwidth is-primary margin-bottom-sm is-large"
          @click.prevent="handleDownload('mp3')"
        >
          MP3
        </button>
        <button
          class="button is-fullwidth is-primary margin-bottom-sm is-large"
          @click.prevent="handleDownload('wav')"
        >
          WAV
        </button>
        <button
          class="button is-fullwidth is-secondary is-large"
          @click.prevent="$store.dispatch('subscriptions/hideDownloadModal')"
        >
          Cancel
        </button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { logSubscriptionDownload } from '@/utils/segment.js'

export default {
  name: 'ThePreviewDownloadModal',

  computed: {
    track: function () {
      return this.$store.getters['subscriptions/trackToDownload']
    },

    showModal: {
      get: function () {
        return this.$store.getters['subscriptions/showDownloadModal']
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.dispatch('subscriptions/showDownloadModal')
        } else {
          this.$store.dispatch('subscriptions/hideDownloadModal')
        }
      }
    }
  },

  methods: {
    handleDownload: function (format) {
      logSubscriptionDownload(this.track.artist.name, this.track.display_title)

      this.$store.dispatch('subscriptions/doSubscriptionOrder')
        .then((response) => {
          const url = response.data.download_tokens[0][format]
          window.location = url
          this.$store.dispatch('subscriptions/hideDownloadModal')
        })
    }
  }
}
</script>

<style>
</style>
